import styled from 'styled-components';

interface IContainer {
  height: number;
  overflowAuto?: boolean;
}

export const Container = styled.div<IContainer>`
  height: ${({ height }) => height}px + 10px;
  margin-top: 16px;
  overflow: ${({ overflowAuto }) => (overflowAuto ? '' : 'hidden')};
`;

export const Separator = styled.div`
  height: 12px;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  margin-bottom: 10px;
`;

export const Cancel = styled.button`
  color: #474d66;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  outline: 0;
`;

export const Done = styled.button`
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#1371FE')};
  font-weight: 500;
  font-size: 14px;
  margin-left: 40px;
  background: none;
  border: none;
  outline: 0;
`;
